// Marchio di qualità RAL — usa esclusivamente il file originale, senza alterarne
// proporzioni, colori o contenuto (si imposta solo l'altezza, larghezza automatica).
export const RalMark = ({ className = "h-16 w-auto" }) => (
  <img src="/brands/ral.webp" alt="Marchio di qualità RAL — Calze compressive medicali" className={className} />
);

export const RAL_TEXT =
  "Il marchio di qualità RAL è applicabile esclusivamente agli specifici dispositivi compressivi medicali che hanno ottenuto la relativa certificazione. La sua presenza nella scheda identifica il singolo prodotto certificato e non l'intera gamma SCHIEBLER né Medisistem.";

// Sezione dedicata (pagina SCHIEBLER)
export const RalSection = () => (
  <section className="py-16 lg:py-20 bg-white" data-testid="ral-section">
    <div className="container-x">
      <div className="grid items-center gap-8 rounded-3xl border border-[#E7EDF2] bg-cloud p-8 lg:grid-cols-[auto_1fr] lg:gap-12 lg:p-12">
        <RalMark className="mx-auto h-28 w-auto lg:mx-0" />
        <div>
          <span className="eyebrow">Qualità dei dispositivi compressivi medicali</span>
          <p className="mt-4 text-lg text-navy/85 leading-relaxed">{RAL_TEXT}</p>
        </div>
      </div>
    </div>
  </section>
);

// Blocco tecnico (scheda prodotto — solo prodotti con ralCertified: true)
export const RalTechBlock = () => (
  <div className="mt-8 flex flex-col items-start gap-4 rounded-2xl border border-[#E7EDF2] bg-cloud p-5 sm:flex-row sm:items-center" data-testid="ral-tech-block">
    <RalMark className="h-16 w-auto shrink-0" />
    <p className="text-sm text-navy/70 leading-relaxed">{RAL_TEXT}</p>
  </div>
);

// Logo piccolo accanto al nome prodotto (solo ralCertified: true)
export const RalBadge = () => (
  <span className="inline-flex items-center" title="Prodotto con marchio di qualità RAL" data-testid="ral-badge">
    <img src="/brands/ral.webp" alt="Prodotto con marchio di qualità RAL" className="h-10 w-auto" />
  </span>
);
